import getConfigForCurrentEnv from '@hmhco/amp-core-env/src/getConfig';

export const getRedirectUrl = locationHash => {
  const plsFragments = ['LeadersCorner', 'TeachersCorner', 'FamilyRoom'];
  const hasPlsFragment = plsFragments.some(fragment =>
    locationHash.includes(fragment),
  );
  const ampRoot = getConfigForCurrentEnv().liftRoot;
  if (hasPlsFragment) {
    return `${ampRoot}${locationHash}`;
  }
  return ampRoot;
};

export function redirectToLift() {
  const redirectUrl = getRedirectUrl(window.location.hash);
  window.location.assign(redirectUrl);
}

redirectToLift();
